<div class="loading-background" [@inOutAnimation] *ngIf="IsLoading">
  <div class="style-outer-container">
    <div class="style-inner-container" *ngIf="!IsLogin">
      <nav class="style-navigation">
        <div class="style-navigation-ci">
          <img src="/assets/img/schulio-border.png" />
        </div>
        <ul class="style-navigation-items">
          <li id="logout">
            <a
              (click)="logout()"
              title="Logout"
              class="style-navigation-icon-entry"
            >
              <span class="icon"><i class="gg-log-out"></i></span>
              <span class="label">Logout</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div style="height: 20vh" *ngIf="IsLogin"></div>

    <div id="loading">
      <img src="/assets/img/schulio-border.png" />

      <div class="loading-bar" [class.hide]="DisplayBar">
        <div [style.width]="Width"></div>
      </div>
      <p *ngIf="!IsDisconnected">Bibliotheksdaten werden geladen.</p>

      <p *ngIf="IsDisconnected">
        Bitte überprüfen Sie Ihre Internetverbindung.
      </p>

      <button class="popup-button" block color="primary" (click)="restart()">
        <span class="icon"><i class="gg-redo"></i></span>
        Schulio neu starten
      </button>
    </div>
  </div>
</div>
